/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */

import PaletteIconCheckCircleFilled from '@telus-uds/palette-koodo/build/rn/icons/CheckCircleFilled'
import PaletteIconExclamationOctagon from '@telus-uds/palette-koodo/build/rn/icons/ExclamationOctagon'
const theme = {
  appearances: {
    icon: { type: 'variant', values: [ true ] },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning', 'feature' ]
    }
  },
  rules: [
    {
      if: { validation: 'error' },
      tokens: { backgroundColor: '#fcd3c6' }
    },
    {
      if: { validation: 'success' },
      tokens: { backgroundColor: '#c5f2cc' }
    },
    {
      if: { icon: true, validation: 'success' },
      tokens: {
        backgroundColor: '#c5f2cc',
        icon: PaletteIconCheckCircleFilled,
        iconColor: '#1c7b2b'
      }
    },
    {
      if: { icon: true, validation: 'error' },
      tokens: {
        backgroundColor: '#fcd3c6',
        icon: PaletteIconExclamationOctagon,
        iconColor: '#c9370b'
      }
    }
  ],
  tokens: {
    backgroundColor: '#efefef',
    borderColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 0,
    borderWidth: 0,
    color: '#000000',
    contentFontSize: 16,
    fontName: 'StagSans',
    fontWeight: '400',
    icon: null,
    iconColor: 'rgba(0, 0, 0, 0)',
    iconGap: 8,
    iconSize: 20,
    lineHeight: 1.5,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    space: 2,
    titleFontSize: 16
  }
}
export default theme
